// extracted by mini-css-extract-plugin
module.exports = {"coloumnBtns":"PlayerActionButtons_coloumnBtns__31qwc","editPlayer":"PlayerActionButtons_editPlayer__37AAn","removePlayer":"PlayerActionButtons_removePlayer__tATd0"};